import { isEmpty } from "lodash";

export const CTXM_ACTIONS = {
  CTXM_LIST_RQ: "CTXM_LIST_RQ",
  CTXM_LIST_OK: "CTXM_LIST_OK",
  CTXM_LIST_FAIL: "CTXM_LIST_FAIL",

  CTXM_UPDATE_LIST_RQ: "CTXM_UPDATE_LIST_RQ",
  CTXM_UPDATE_LIST_OK: "CTXM_UPDATE_LIST_OK",
  CTXM_UPDATE_LIST_FAIL: "CTXM_UPDATE_LIST_FAIL",

  CTXM_GET_RQ: "CTXM_GET_RQ",
  CTXM_GET_OK: "CTXM_GET_OK",
  CTXM_GET_FAIL: "CTXM_GET_FAIL",

  CTXM_ADD_RQ: "CTXM_ADD_RQ",
  CTXM_ADD_OK: "CTXM_ADD_OK",
  CTXM_ADD_FAIL: "CTXM_ADD_FAIL",

  CTXM_UPDATE_RQ: "CTXM_UPDATE_RQ",
  CTXM_UPDATE_OK: "CTXM_UPDATE_OK",
  CTXM_UPDATE_FAIL: "CTXM_UPDATE_FAIL",

  CTXM_DELETE_RQ: "CTXM_DELETE_RQ",
  CTXM_DELETE_OK: "CTXM_DELETE_OK",
  CTXM_DELETE_FAIL: "CTXM_DELETE_FAIL",

  CTXM_DUPLICATE_RQ: "CTXM_DUPLICATE_RQ",
  CTXM_DUPLICATE_OK: "CTXM_DUPLICATE_OK",
  CTXM_DUPLICATE_FAIL: "CTXM_DUPLICATE_FAIL",

  CTXM_RESET_ALL: "CTXM_RESET_ALL",
};

export const contextModelI = {
  ctxm_contextModels: [],
  ctxm_list_loading: false,
  ctxm_update_list_loading: false,
  ctxm_get_loading: false,
  ctxm_add_loading: false,
  ctxm_update_loading: false,
  ctxm_delete_loading: false,
  ctxm_duplicate_loading: false,
  ctxm_error: null,
};

export const contextModelReducer = (state: any, action: any) => {
  switch (action.type) {
    case CTXM_ACTIONS.CTXM_LIST_RQ:
      return { ...state, ctxm_list_loading: true, error: null };
    case CTXM_ACTIONS.CTXM_LIST_FAIL:
      return { ...state, ctxm_list_loading: false };
    case CTXM_ACTIONS.CTXM_LIST_OK:
      return { ...state, ctxm_list_loading: false, ctxm_contextModels: action.data };

    case CTXM_ACTIONS.CTXM_UPDATE_LIST_RQ:
      return { ...state, ctxm_update_list_loading: true, error: null };
    case CTXM_ACTIONS.CTXM_UPDATE_LIST_FAIL:
      return { ...state, ctxm_update_list_loading: false };
    case CTXM_ACTIONS.CTXM_UPDATE_LIST_OK:
      return {
        ...state,
        ctxm_update_list_loading: false,
        ctxm_contextModels: [...state.ctxm_contextModels, ...action.data],
      };

    case CTXM_ACTIONS.CTXM_GET_RQ:
      return { ...state, ctxm_get_loading: true, error: null };
    case CTXM_ACTIONS.CTXM_GET_FAIL:
      return { ...state, ctxm_get_loading: false };
    case CTXM_ACTIONS.CTXM_GET_OK:
      return { ...state, ctxm_get_loading: false };

    case CTXM_ACTIONS.CTXM_ADD_RQ:
      return { ...state, ctxm_add_loading: true, error: null };
    case CTXM_ACTIONS.CTXM_ADD_FAIL:
      return { ...state, ctxm_add_loading: false };
    case CTXM_ACTIONS.CTXM_ADD_OK:
      return {
        ...state,
        ctxm_add_loading: false,
        ctxm_contextModels: isEmpty(action.data)
          ? [...state.ctxm_contextModels]
          : [action.data, ...state.ctxm_contextModels],
      };

    case CTXM_ACTIONS.CTXM_DUPLICATE_RQ:
      return { ...state, ctxm_duplicate_loading: true, error: null };
    case CTXM_ACTIONS.CTXM_DUPLICATE_FAIL:
      return { ...state, ctxm_duplicate_loading: false };
    case CTXM_ACTIONS.CTXM_DUPLICATE_OK:
      return {
        ...state,
        ctxm_add_loading: false,
        ctxm_contextModels: isEmpty(action.data)
          ? [...state.ctxm_contextModels]
          : [...action.data, ...state.ctxm_contextModels],
      };

    case CTXM_ACTIONS.CTXM_UPDATE_RQ:
      return { ...state, ctxm_update_loading: true, error: null };
    case CTXM_ACTIONS.CTXM_UPDATE_FAIL:
      return { ...state, ctxm_update_loading: false };
    case CTXM_ACTIONS.CTXM_UPDATE_OK:
      if (isEmpty(action.data)) {
        return;
      }
      return {
        ...state,
        ctxm_update_loading: false,
        ctxm_contextModels: state.ctxm_contextModels.map((item: any) =>
          item.id === action.data.id ? action?.data : item,
        ),
      };

    case CTXM_ACTIONS.CTXM_DELETE_RQ:
      return { ...state, ctxm_delete_loading: true, error: null };
    case CTXM_ACTIONS.CTXM_DELETE_FAIL:
      return { ...state, ctxm_delete_loading: false };
    case CTXM_ACTIONS.CTXM_DELETE_OK:
      return {
        ...state,
        ctxm_delete_loading: false,
        ctxm_contextModels: state.ctxm_contextModels.filter(
          (item: any) => !action.data.includes(item.id),
        ),
      };

    case CTXM_ACTIONS.CTXM_RESET_ALL:
      return {
        ...state,
        ctxm_contextModels: [],
        ctxm_list_loading: false,
        ctxm_update_list_loading: false,
        ctxm_get_loading: false,
        ctxm_add_loading: false,
        ctxm_update_loading: false,
        ctxm_delete_loading: false,
        ctxm_duplicate_loading: false,
        ctxm_error: null,
      };
    default:
      return state;
  }
};
